// extracted by mini-css-extract-plugin
export default {"container":"EditableInput_container__3DFl8","input":"EditableInput_input__B9RkV"};